export const rules = function () {
    return {
      discount: [
        { required: true, message: '请输入折扣比例', trigger: ['blur', 'change'] },
      ],
    }
}

export default {}